import { useEffect } from 'react'

import subscriptionAnalytics from '~/analytics/subscription/subscriptionAnalytics'

import ModalContentV1 from './ModalContentV1'

export interface SubscriptionModalV1Props {
  onCtaClick?: () => void
  isTrial?: boolean
  inline?: boolean
}

export function SubscriptionModalV1(props: SubscriptionModalV1Props): React.ReactElement {
  useEffect(() => {
    subscriptionAnalytics.logModalView('paywall_modal_subscription')
    subscriptionAnalytics.logPayWall()
  }, [])

  const inlineLayout = (
    <aside>
      <section className="h-full flex items-center justify-center">
        <ModalContentV1 {...props} />
      </section>
    </aside>
  )

  if (props.inline) {
    return inlineLayout
  }

  return (
    <aside className="fixed z-modal-top inset-0 bg-black/70 backdrop-filter backdrop-blur-sm overflow-y-auto">
      <section className="min-h-full flex items-center justify-center p-3 sm:p-4">
        <ModalContentV1 {...props} />
      </section>
    </aside>
  )
}
